import { camelCase } from 'lodash';
import { ShiftType, EmploymentTypes } from '@common/graphql';
import { BillingCardEmploymentTypeRatesType } from '@institutions/graphql';

export type RatesByShiftType = {
  travelerRate: number;
  localRate: number;
  directSourcingRate: number;
};

export const RATES_URLS = {
  BASE: '/works/admin/rates',
  LONG_TERM: '/works/admin/rates/long-term',
  INCENTIVES: '/works/admin/rates/incentives',
} as const;

export function getBillingCardRateByShiftType(
  billingCard?: BillingCardEmploymentTypeRatesType | null,
  shiftType?: ShiftType | null
): RatesByShiftType | null {
  if (
    !billingCard ||
    !billingCard.travelerRate ||
    !billingCard.localRate ||
    !billingCard.directSourcingRate ||
    !shiftType
  ) {
    return null;
  }

  return {
    travelerRate: billingCard.travelerRate?.[`${shiftType}BillingRate`],
    localRate: billingCard.localRate?.[`${shiftType}BillingRate`],
    directSourcingRate:
      billingCard.directSourcingRate?.[`${shiftType}BillingRate`],
  };
}

export function getRateByEmploymentType(
  billingCard?: BillingCardEmploymentTypeRatesType | null,
  shiftType?: ShiftType,
  employmentType?: EmploymentTypes | null
): number | null {
  const rates = getBillingCardRateByShiftType(billingCard, shiftType);

  if (!rates) {
    return null;
  }

  const employmentTypeKey = employmentType && camelCase(employmentType);

  const formattedEmploymentType =
    `${employmentTypeKey}Rate` as keyof RatesByShiftType;
  return rates[formattedEmploymentType];
}
